export default __webpack_public_path__ + "static/media/lotus.12655252.svg";